import BaseApi from "./base.api";
import ApiService from "@services/api.service";

export default {
    ...BaseApi,
    ...{
        resource: "students",

        saveColGrade(params = null) {
            return ApiService.post(`/${this.resource}/save-col-grade`, params);
        },

        saveComment(params = null) {
            return ApiService.post(`/${this.resource}/save-comment`, params);
        },

        saveColsGrade(params = null) {
            return ApiService.post(
                `/${this.resource}/save-students-cols-grade`,
                params
            );
        },

        updateColGrade(params = null) {
            return ApiService.post(`/${this.resource}/update-col-grade`, params);
        },
        updateColumn(params = null) {
            return ApiService.post(
                `/${this.resource}/update-col/` + params.id,
                params
            );
        },
        getRegisterReport(params = null) {
            return ApiService.post(`/${this.resource}/register-report`, params);
        },
        getRegisterReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/register-report`, params);
        },
        block(params = null) {
            return ApiService.post(`${this.resource}/block/${params.id}`, params);
        },
        print(params) {
            return ApiService.post(`${this.resource}/print`, params);
        },
        transferClass(params) {
            return ApiService.post(`${this.resource}/update-class`, params);
        },
        deleteSponsor(params) {
            return ApiService.get(
                `${this.resource}/delete-sponsor/${params}`,
                params
            );
        },
        exportExcel(params) {
            return ApiService.get(`${this.resource}/excel`, params);
        },
        exportStagesExcel(params) {
            return ApiService.get(`${this.resource}/stages-excel`, params);
        },
        exportSpecialNeedReportExcel(params) {
            return ApiService.get(
                `${this.resource}/special-needs-report/excel`,
                params
            );
        },
        onHold(id, params = null) {
            return ApiService.get(`${this.resource}/onHold/${id}`, params);
        },
        storeFeeType(params) {
            return ApiService.post(`${this.resource}/fee-types`, params);
        },
        cancellation(params) {
            return ApiService.post(
                `${this.resource}/cancellation/${params.id}`,
                params
            );
        },
        withdrawal(params) {
            return ApiService.post(`${this.resource}/withdrawal`, params);
        },
        approveStudentWithdrawal(params) {
            return ApiService.get(`${this.resource}/approve-withdrawal/${params.id}`);
        },
        approveStudentCancellation(params) {
            return ApiService.get(
                `${this.resource}/approve-cancellation/${params.id}`
            );
        },
        cancelStudentWithdrawal(params) {
            return ApiService.get(`${this.resource}/cancel-withdrawal/${params.id}`);
        },
        blockBulk(params) {
            return ApiService.post(`${this.resource}/blockBulk`, params);
        },
        getStatusTypes(params) {
            return ApiService.get(`${this.resource}/status`, params);
        },
        getRegistrationStatus(params) {
            return ApiService.get(`${this.resource}/registration-status`, params);
        },
        getStudyStatus(params) {
            return ApiService.get(`${this.resource}/study-status`, params);
        },
        getGradebookReport(params) {
            return ApiService.get(`${this.resource}/gradebook-report`, params);
        },
        getStudentTypes(params) {
            return ApiService.get(`${this.resource}/student-types`, params);
        },

        getGenderTypes(params) {
            return ApiService.get(`${this.resource}/gender-types`, params);
        },

        getExpensesTypes(params) {
            return ApiService.get(`${this.resource}/expenses-types`, params);
        },

        getOrphanStatus(params) {
            return ApiService.get(`${this.resource}/get/orphan/status`, params);
        },

        statisticalRegisteredReport(params) {
            return ApiService.get(
                `${this.resource}/statistical-registered_report`,
                params
            );
        },

        statistics(params) {
            return ApiService.get(`${this.resource}/statistics-report`, params);
        },
        studentNormalStatistics(params) {
            return ApiService.get(
                `${this.resource}/normal-statistics-report`,
                params
            );
        },
        studentStatistics(params) {
            return ApiService.get(
                `${this.resource}/students-statistical-report`,
                params
            );
        },

        getStudentDuesReport(params) {
            return ApiService.get(`${this.resource}/getStudentDuesReport`, params);
        },

        getRegisterStudentReport(params) {
            return ApiService.get(`${this.resource}/register-report/excel`, params);
        },

        getConnectionsReport(params) {
            return ApiService.get(`${this.resource}/report/contacts`, params);
        },

        exportNormalStatisticsReport(params) {
            return ApiService.get(
                `${this.resource}/normal-statistics-report/excel`,
                params
            );
        },

        addGuardianReply(params) {
            return ApiService.post(`${this.resource}/guardian/reply`, params);
        },
        studentMixStatistics(params) {
            return ApiService.get(`${this.resource}/mix-statistics-report`, params);
        },

        exportContactsReport(params) {
            return ApiService.get(`${this.resource}/contacts-report/excel`, params);
        },

        exportClassesByPhone(params) {
            return ApiService.get(
                `${this.resource}/classes-by-phone-report/excel`,
                params
            );
        },
        getStudentsReportClassByStudyStatus(params = null) {
            return ApiService.get(
                `/${this.resource}/report/class-by-study-status`,
                params
            );
        },
        getStudentsReportClassByStudyStatusExcel(params = null) {
            return ApiService.get(
                `/${this.resource}/report/class-by-study-status-excel`,
                params
            );
        },
        getStudentsDataReport(params = null) {
            return ApiService.get(`/${this.resource}/report/data`, params);
        },
        getStudentsDataReportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/student-data-report`,
                params
            );
        },
        getSpecialNeeds(params = null) {
            return ApiService.get(`/${this.resource}/report/special-needs`, params);
        },
        getSpecialNeedsEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/special-needs`, params);
        },
        getStudentsDataReportExport(params = null) {
            return ApiService.get(`/${this.resource}/report/data/export`, params);
        },
        getStudentsDataReportExportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/student-data-report/export`,
                params
            );
        },
        getStudentsWithdrawalsReport(params = null) {
            return ApiService.get(`/${this.resource}/report/withdrawals`, params);
        },
        getStudentsWithdrawalsReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/withdrawal-report`, params);
        },
        getStudentsEnrollmentReport(params = null) {
            return ApiService.get(
                `/${this.resource}/report/student-enrollment`,
                params
            );
        },
        getStudentsEnrollmentReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/enrollment-report`, params);
        },
        getStudentsCountStatisticsReport(params = null) {
            return ApiService.get(
                `/${this.resource}/report/students-count-statistics`,
                params
            );
        },
        getStudentsCountStatisticsReportExport(params = null) {
            return ApiService.get(
                `/${this.resource}/report/students-count-statistics/export`,
                params
            );
        },
        getFinancialStatement(params = null) {
            return ApiService.get(
                `/${this.resource}/report/student/financial-statement`,
                params
            );
        },
        exportOrphanStudentsExcel(params = null) {
            return ApiService.post(`/${this.resource}/orphan-excel`, params);
        },
        storeStudentException(params = null) {
            return ApiService.post(`/${this.resource}/exceptions`, params);
        },
        exportExceptionStudentsExcel(params = null) {
            return ApiService.post(`/${this.resource}/exceptions-excel`, params);
        },
        changeClass(params) {
            return ApiService.post(`${this.resource}/change-class`, params);
        },
        getStageStudentTypes(params) {
            return ApiService.get(
                `${this.resource}/stage-student-type-report`,
                params
            );
        },
        getStageStudentTypesEnhanced(params) {
            return ApiService.get(
                `/mongo-report-students/stage-student-types`,
                params
            );
        },
        reEnrolledReport(params) {
            return ApiService.get(`${this.resource}/re-enrollment-report`, params);
        },
        reEnrolledReportExcel(params) {
            return ApiService.get(
                `${this.resource}/re-enrollment-report-excel`,
                params
            );
        },
        getDiscounts(params = null) {
            return ApiService.get(`/student-discounts`, params);
        },
        getExpenseTypes(params = null) {
            return ApiService.get(`/student-expense-types`, params);
        },
        getlistSimple(params = null) {
            return ApiService.get(`${this.resource}/listSimple`, params);
        },

        changeStatus(params = null) {
            return ApiService.post(`${this.resource}/change-student-status`, params);
        },

        changeStudentType(params = null) {
            return ApiService.post(`${this.resource}/change-student-type`, params);
        },

        cancelEnrollment(params = null) {
            return ApiService.post(`${this.resource}/cancel-enrollment`, params);
        },

        getStudentsTransformationReport(params = null) {
            return ApiService.get(`/${this.resource}/report/transformations`, params);
        },
        getStudentsTransformationReportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/transformation-report`,
                params
            );
        },

        validate(data) {
            return ApiService.post(`/${this.resource}/validate`, data);
        },

        cancelCancellation(params) {
            return ApiService.get(
                `${this.resource}/cancel-cancellation/${params.id}`
            );
        },
        studentRevenueTotal(params) {
            return ApiService.get(`${this.resource}/detailed-total-revenue`, params);
        },
        exportRevenueExcel(params) {
            return ApiService.get(`${this.resource}/revenue-excel`, params);
        },

        attachSearch(params) {
            return ApiService.get("students/attach-search", { params });
        },

        syncTeamsStudent(studentId) {
            return ApiService.post(`/${this.resource}/sync-one`, {
                student_id: studentId,
            });
        },

        // Enhanced MongoDB Reports
        getEducationalStateReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/educational-state`, params);
        },

        getNewStudentsReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/new-students`, params);
        },

        getUnenrollmentStudentsReportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/unenrollment-students`,
                params
            );
        },

        getStudentHistoryReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/student-history`, params);
        },

        getOrphanStudentsReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/orphan-students`, params);
        },

        getParentLogsReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/parent-logs`, params);
        },

        getReEnrollmentReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/re-enrollment`, params);
        },

        getStudentsByClassReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/students-by-class`, params);
        },

        getClassesWithCivilIdReportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/classes-with-civil-id`,
                params
            );
        },

        getClassesWithAgeReportEnhanced(params = null) {
            return ApiService.get(`/mongo-report-students/classes-with-age`, params);
        },

        getClassesByNationalityAndReligionReportEnhanced(params = null) {
            return ApiService.get(
                `/mongo-report-students/classes-by-nationality-religion`,
                params
            );
        },
        getAttendance(params) {
            return ApiService.get("students/attendance", params);
        },
        getStudentsNames(params) {
            return ApiService.get("students/student-names", params);
        },
        getStudentGrades(params) {
            return ApiService.get("students/student-grades", params);
        },
        getStudentSubjects(params) {
            return ApiService.get("students/student-subjects", params);
        },
        getStudentchats(params) {
            return ApiService.get("students/student-chats", params);
        },

        deleteGuardian(familyId, studentId) {
            return ApiService.delete(`students/guardian/${familyId}/${studentId}`);
        },

        getStudentsAddressReport(params = {}) {
            return ApiService.get(`${this.resource}/address-report`, params)
        },
        exportStudentsAddressReport(params = {}) {
            return ApiService.post(`${this.resource}/export-address-report`, params)
        },

        exportStudentsWithdrawalsReport(params = null) {
            return ApiService.get(`/${this.resource}/report/export-withdrawals`, params);
        },

        getStudentsWithIncidents(params = null) {
            return ApiService.get(`/${this.resource}/with-incidents`, params);
        }

    },
};
